import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Header from './Header';
import FormPicker from './FormPicker';

const styles = () => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {},
  form: {},
});

const MainContent = ({
  className,
  classes,
}) => {
  const { pageContentCollection } = usePageContentContext();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Header className={classes.header} />
      <FormPicker
        className={classes.form}
        collection={pageContentCollection}
      />
    </Box>
  );
};

MainContent.defaultProps = {
  className: '',
};

MainContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainContent);
